import { SimpleIconProps } from '../types';

export const IconDelete = ({ className, color = '#4E4E56', onClick }: SimpleIconProps) => (
  <svg
    aria-label="icon-delete"
    className={className}
    fill="none"
    height="12"
    onClick={onClick}
    role="img"
    viewBox="0 0 10 12"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.50002 10.0833C1.50002 10.725 2.02502 11.25 2.66669 11.25H7.33335C7.97502 11.25 8.50002 10.725 8.50002 10.0833V3.08333H1.50002V10.0833ZM9.08335 1.33333H7.04169L6.45835 0.75H3.54169L2.95835 1.33333H0.916687V2.5H9.08335V1.33333Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
